import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './AppointmentBooking.css';

function AppointmentBooking() {
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(currentDate);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const highlightedDates = ['2025-03-01', '2025-03-02', '2025-03-04', '2025-03-06', '2025-03-07', '2025-03-09'];

    // Function to check if a date should be highlighted
    const isHighlighted = (date) => {
        return highlightedDates.includes(date.toISOString().split('T')[0]);
    };

    // Function to disable dates that are not highlighted
    const tileDisabled = ({ date }) => {
        return !isHighlighted(date); // Disable all dates except highlighted ones
    };

    return (
        <motion.section
            className="AppointmentBooking"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1, duration: 0.5 }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-12 mt-3 px-3">
                        <div className="card contentbox-booking mb-2">
                            <div className="card-body p-0">
                                <div className="row align-items-center">
                                    <div className="col-12">
                                        <Calendar
                                            minDate={currentDate}
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            tileClassName={({ date, view }) =>
                                                view === 'month' && isHighlighted(date)
                                                    ? 'highlighted-tile'
                                                    : null
                                            }
                                            tileDisabled={tileDisabled} // Disable non-highlighted dates
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </motion.section>
    );
}

export default AppointmentBooking;
